<template>
  <layout-fullpage>
    <page-headline tag="h1" title="系統公告" />
     <loading :show="apiLoading" />
    <!-- 手機版 -->
    <div class="d-lg-none">
      <h5 class="systemMsg">{{ msg }}</h5>
    </div>

    <!-- 電腦版 -->
    <div class="d-none d-lg-block">
      <h4 class="systemMsg">{{ msg }}</h4>
    </div>
  </layout-fullpage>
</template>

<script>
import Loading from '@/components/Loading.vue';
import LayoutFullpage from '@/layouts/Fullpage.vue';

export default {
  name: 'Announcement',

  components: {
    Loading,
    LayoutFullpage,
  },

  data() {
    return {
      msg: '目前已達使用人數上限，請稍後再登入，謝謝!!',
      apiLoading: false,
    };
  },
  created() {

  },



  methods: {

  },
};
</script>
